var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"html-content-block"},[_c('div',{staticClass:"html-content-block__container"},[_c('div',{staticClass:"html-content-block__content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }